module.exports = __webpack_public_path__ + "static/media/Imagen 10.ca12ce8d.jpg";